import { Alert, Button } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";

import { WebLayout } from "./components/web-layout";
import React from "react";

const useQueryParams = () => {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
};

export default function ErrorPage() {
    const queryParams = useQueryParams();
    const navigate = useNavigate();

    return (
        <WebLayout showFooter={false}>
            <Alert variant="danger">
                <Alert.Heading>Network error!</Alert.Heading>
                <p>
                    Please check your internet connection. If the error persists
                    with active internet connection, please contact
                    administrator.
                </p>

                <Button
                    onClick={() =>
                        navigate(queryParams.get("on") || "/", {
                            replace: true,
                        })
                    }
                >
                    Reload page
                </Button>
            </Alert>
        </WebLayout>
    );
}
